<template>
  <div class="program">
    <div id="program" class="sec mt-10">
      <v-container>
        <div class="display-2 head" data-aos="fade-up">Customer Service Steerage Program</div>

        <v-card
          flat
          rounded="lg"
          data-aos="fade-up"
        >
          <v-row align="center">
            <v-col
              cols="6"
              class="ma-0 pa-0 hidden-sm-and-down"
            >
            <!-- Floating image -->
            <v-img
              contain
              width="150px"
              src="@/assets/images/partners/intellicare.png"
              class="floating-image"
            ></v-img>
            
              <v-img
                width="100vw"
                height="100vh"
                src="@/assets/images/others/login.jpg"
                class="left-image"
              ></v-img>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6">
              <v-form ref="programForm">
                <div :class="[ $vuetify.breakpoint.mdAndUp ? 'form-web' : 'form-mobile' ]">
                  <!-- Member's name -->
                  <v-text-field
                    label="Member's name"
                  ></v-text-field>

                  <!-- Card number -->
                  <v-text-field
                    label="Card number"
                  ></v-text-field>

                  <!-- Contact number -->
                  <v-text-field
                    label="Contact number"
                  ></v-text-field>

                  <!-- Intellicare team code -->
                  <v-text-field
                    label="Intellicare team code"
                  ></v-text-field>

                  <!-- Message -->
                  <v-textarea
                    auto-grow
                    label="Message"
                  ></v-textarea>

                  <v-card-actions class="mt-5">
                    <base-button
                      name="Submit"
                      x-large
                      color="#c2dffc"
                      min-width="50%"
                      class="blue--text text--darken-2"
                    >
                    </base-button>
                    <base-button
                      name="Cancel"
                      x-large
                      color="#1665ce"
                      min-width="50%"
                      dark
                    >
                    </base-button>
                  </v-card-actions>
                </div>
              </v-form>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CustomerServiceSteerage",
    data: () => ({
      //
    }),
    mounted() {
      //
    },
    methods: {
      //
    },
  }
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.form-mobile {
  padding: 10%;
}

.form-web {
  padding: 10% 15% 10% 15%;
}

.left-image {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.floating-image {
  position:absolute;
  margin-left:2%;
  margin-top:2%;
  z-index:1;
}
</style>